module.exports = __webpack_public_path__ + "static/media/step-1.2ab6a316.png";